export default (theme) => ({
  weekCalendarWrapper: {
    // display: 'flex',
    flexGrow: 1,
    width: '100%',
    height: 'calc(100vh - 145px)',
    position: 'relative',
    tableLayout: 'fixed',
    borderCollapse: 'separate',
  },
  header: {
    width: '100%',
    position: 'sticky',
    top: 0,
    zIndex: 5,
  },
  headerCell: {
    width: 'calc(100% / 7)',
    height: 52,
    border: `1px solid ${theme.palette.borderColor.lightGrey}`,
    padding: '8px 10px',
    color: theme.palette.textColor.secondary,
    backgroundColor: '#FFFFFF',

    '& + $headerCell': {
      borderLeft: 'none',
    }
  },
  todayHeaderCell: {
    backgroundColor: '#F8F3F1',
    color: '#E87C35',
  },
  headerCellContent: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  headerDateGroup: {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
    fontWeight: 600,
    gap: '2px',
  },
  headerDate: {
    fontSize: '16px',
  },
  headerWeekDay: {
    fontSize: '14px',
  },
  headerCountGroup: {
    display: 'flex',
    alignItems: 'flex-end',
    flexDirection: 'column',
    fontWeight: 500,
    gap: '2px',
  },
  todayBadge: {
    color: '#E87C35',
    fontSize: 12,
    fontWeight: 700,
    textTransform: 'uppercase',
    padding: '2px 6px',
    borderRadius: 12,
    backgroundColor: 'rgba(232, 124, 53, 0.15)'
  },
  headerCount: {
    fontSize: 12,
    color: theme.palette.textColor.secondary
  },
  bodyCell: {
    border: `1px solid ${theme.palette.borderColor.lightGrey}`,
    borderTop: 'none',
    position: 'relative',
    verticalAlign: 'top',

    '& + $bodyCell': {
      borderLeft: 'none',
    }
  },
  bodyCellScroller: {
    height: `calc(100vh - 198px)`,
    overflowY: 'auto',

    '&::-webkit-scrollbar': {
      width: 12,
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'rgba(0, 0, 0, 0.22)',
      border: '2px solid transparent',
      backgroundClip: 'content-box',
      borderRadius: 4,
      '&:hover': {
        background: 'rgba(0, 0, 0, 0.38)',
        backgroundClip: 'content-box',
      },
    },
    // keep caret buttons; shift arrow icon slightly left
    // '&::-webkit-scrollbar-button': {
    //   // display: 'block',
    //   // height: 14,
    //   // backgroundRepeat: 'no-repeat',
    //   // backgroundSize: '8px 4px',
    // },
    // '&::-webkit-scrollbar-button:single-button:vertical:decrement': {
    //   backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 4'><path d='M4 0 L8 4 L0 4 Z' fill='%23999'/></svg>\")",
    //   backgroundPosition: '2px center',
    // },
    // '&::-webkit-scrollbar-button:single-button:vertical:increment': {
    //   backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 4'><path d='M0 0 L8 0 L4 4 Z' fill='%23999'/></svg>\")",
    //   backgroundPosition: '2px center',
    // },
  }
})